import { render } from "./OSList.vue?vue&type=template&id=50d29e42&scoped=true"
import script from "./OSList.vue?vue&type=script&lang=js"
export * from "./OSList.vue?vue&type=script&lang=js"

import "./OSList.vue?vue&type=style&index=0&id=50d29e42&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\ApontaFacil\\dashboard\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d29e42"]])

export default __exports__